import clsx from "clsx";
import { StaticImage } from "gatsby-plugin-image";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LanguageContext, text } from "../../container/language";
import Paragraph from "../Article/Paragraph";
import Paragraphs from "../Article/Paragraphs";

<div class="row">
  <div class="col-12 col-md-8">.col-12 .col-md-8</div>
  <div class="col-6 col-md-4">.col-6 .col-md-4</div>
</div>;

export const Partners = () => {
  const { userLanguage } = useContext(LanguageContext);
  const { t } = useTranslation();

  return (
    <section className="wrapper bg-light wrapper-border">
      <div className="container py-8 py-md-8">
        <h2 className="fs-15 text-uppercase text-muted text-center mb-8">
          {t("partners")}
        </h2>
        <div className="row">
          <div className="col-6 col-md-3 px-5">
            <StaticImage
              src="../../../static/images/partners/council-logo.png"
              alt="Council of Europe"
            />
          </div>
          <div className="col-6 col-md-3 px-5">
            <StaticImage
              src="../../../static/images/partners/euralius.png"
              alt="Euralius"
            />
          </div>
          <div className="col-6 col-md-3 px-5">
            <StaticImage
              src="../../../static/images/partners/european-commision-logo.png"
              alt="European Commision"
            />
          </div>
          <div className="col-6 col-md-3 px-5">
            <StaticImage
              src="../../../static/images/partners/osce-logo.png"
              alt="OSCE"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
